var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _g2, _g3, _g4, _g5, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinechartThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1072,
    height: 659,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    viewBox: "0 0 1072 659",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1072,
    height: 659,
    x: 0,
    y: 0,
    id: 0,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.1893 619.5L1029.12 619.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1893 526.5L1029.12 526.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1893 433.5L1029.12 433.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1893 339.5L1029.12 339.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1893 246.5L1029.12 246.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1893 153.5L1029.12 153.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1893 60.5L1029.12 60.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1893 619.5L1029.12 619.5",
    fill: "none",
    stroke: "#6E7079",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 619.23L70.5 624.23",
    fill: "none",
    stroke: "#6E7079"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M230.5 619.23L230.5 624.23",
    fill: "none",
    stroke: "#6E7079"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 619.23L390.5 624.23",
    fill: "none",
    stroke: "#6E7079"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M549.5 619.23L549.5 624.23",
    fill: "none",
    stroke: "#6E7079"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M709.5 619.23L709.5 624.23",
    fill: "none",
    stroke: "#6E7079"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M869.5 619.23L869.5 624.23",
    fill: "none",
    stroke: "#6E7079"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.5 619.23L1029.5 624.23",
    fill: "none",
    stroke: "#6E7079"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(62.1893 619.23)",
    fill: "#6E7079"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(62.1893 526.025)",
    fill: "#6E7079"
  }, "500"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(62.1893 432.82)",
    fill: "#6E7079"
  }, "1,000"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(62.1893 339.615)",
    fill: "#6E7079"
  }, "1,500"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(62.1893 246.41)",
    fill: "#6E7079"
  }, "2,000"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(62.1893 153.205)",
    fill: "#6E7079"
  }, "2,500"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(62.1893 60)",
    fill: "#6E7079"
  }, "3,000"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(70.1893 627.23)",
    fill: "#6E7079"
  }, "Mon"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(230.0111 627.23)",
    fill: "#6E7079"
  }, "Tue"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(389.8329 627.23)",
    fill: "#6E7079"
  }, "Wed"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(549.6546 627.23)",
    fill: "#6E7079"
  }, "Thu"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(709.4764 627.23)",
    fill: "#6E7079"
  }, "Fri"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(869.2982 627.23)",
    fill: "#6E7079"
  }, "Sat"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(1029.12 627.23)",
    fill: "#6E7079"
  }, "Sun"), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr4-c0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1893 596.8608L230.0111 594.6239L389.8329 600.4026L549.6547 594.251L709.4764 602.4531L869.2982 576.3557L1029.12 580.0839",
    fill: "none",
    stroke: "rgb(84,112,198)",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr4-c1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1893 555.8506L230.0111 560.6973L389.8329 564.7983L549.6547 550.6311L709.4764 548.3942L869.2982 514.8404L1029.12 522.2968",
    fill: "none",
    stroke: "rgb(145,204,117)",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr4-c2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1893 527.8891L230.0111 517.4501L389.8329 527.3299L549.6547 521.924L709.4764 512.9763L869.2982 453.3251L1029.12 445.8687",
    fill: "none",
    stroke: "rgb(250,200,88)",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr4-c3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1893 468.2379L230.0111 455.562L389.8329 471.2205L549.6547 459.663L709.4764 440.2764L869.2982 391.8098L1029.12 386.2175",
    fill: "none",
    stroke: "rgb(238,102,102)",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zr4-c4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1893 315.3817L230.0111 281.8279L389.8329 303.265L549.6547 285.5561L709.4764 199.8075L869.2982 143.8845L1029.12 140.1563",
    fill: "none",
    stroke: "rgb(115,192,222)",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,70.1893,596.8608)",
    fill: "rgb(255,255,255)",
    stroke: "#5470c6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,230.0111,594.6239)",
    fill: "rgb(255,255,255)",
    stroke: "#5470c6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,389.8329,600.4026)",
    fill: "rgb(255,255,255)",
    stroke: "#5470c6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,549.6547,594.251)",
    fill: "rgb(255,255,255)",
    stroke: "#5470c6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,709.4764,602.4531)",
    fill: "rgb(255,255,255)",
    stroke: "#5470c6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,869.2982,576.3557)",
    fill: "rgb(255,255,255)",
    stroke: "#5470c6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,1029.12,580.0839)",
    fill: "rgb(255,255,255)",
    stroke: "#5470c6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,70.1893,555.8506)",
    fill: "rgb(255,255,255)",
    stroke: "#91cc75"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,230.0111,560.6973)",
    fill: "rgb(255,255,255)",
    stroke: "#91cc75"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,389.8329,564.7983)",
    fill: "rgb(255,255,255)",
    stroke: "#91cc75"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,549.6547,550.6311)",
    fill: "rgb(255,255,255)",
    stroke: "#91cc75"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,709.4764,548.3942)",
    fill: "rgb(255,255,255)",
    stroke: "#91cc75"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,869.2982,514.8404)",
    fill: "rgb(255,255,255)",
    stroke: "#91cc75"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,1029.12,522.2968)",
    fill: "rgb(255,255,255)",
    stroke: "#91cc75"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,70.1893,527.8891)",
    fill: "rgb(255,255,255)",
    stroke: "#fac858"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,230.0111,517.4501)",
    fill: "rgb(255,255,255)",
    stroke: "#fac858"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,389.8329,527.3299)",
    fill: "rgb(255,255,255)",
    stroke: "#fac858"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,549.6547,521.924)",
    fill: "rgb(255,255,255)",
    stroke: "#fac858"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,709.4764,512.9763)",
    fill: "rgb(255,255,255)",
    stroke: "#fac858"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,869.2982,453.3251)",
    fill: "rgb(255,255,255)",
    stroke: "#fac858"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,1029.12,445.8687)",
    fill: "rgb(255,255,255)",
    stroke: "#fac858"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,70.1893,468.2379)",
    fill: "rgb(255,255,255)",
    stroke: "#ee6666"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,230.0111,455.562)",
    fill: "rgb(255,255,255)",
    stroke: "#ee6666"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,389.8329,471.2205)",
    fill: "rgb(255,255,255)",
    stroke: "#ee6666"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,549.6547,459.663)",
    fill: "rgb(255,255,255)",
    stroke: "#ee6666"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,709.4764,440.2764)",
    fill: "rgb(255,255,255)",
    stroke: "#ee6666"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,869.2982,391.8098)",
    fill: "rgb(255,255,255)",
    stroke: "#ee6666"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,1029.12,386.2175)",
    fill: "rgb(255,255,255)",
    stroke: "#ee6666"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,70.1893,315.3817)",
    fill: "rgb(255,255,255)",
    stroke: "#73c0de"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,230.0111,281.8279)",
    fill: "rgb(255,255,255)",
    stroke: "#73c0de"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,389.8329,303.265)",
    fill: "rgb(255,255,255)",
    stroke: "#73c0de"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,549.6547,285.5561)",
    fill: "rgb(255,255,255)",
    stroke: "#73c0de"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,709.4764,199.8075)",
    fill: "rgb(255,255,255)",
    stroke: "#73c0de"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,869.2982,143.8845)",
    fill: "rgb(255,255,255)",
    stroke: "#73c0de"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(2,0,0,2,1029.12,140.1563)",
    fill: "rgb(255,255,255)",
    stroke: "#73c0de"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5l10 0l0 10l-10 0Z",
    transform: "translate(536 5)",
    fill: "rgb(0,0,0)",
    fillOpacity: 0,
    stroke: "#ccc",
    strokeWidth: 0
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5l57.0127 0l0 28l-57.0127 0Z",
    transform: "translate(5 5)",
    fill: "rgb(0,0,0)",
    fillOpacity: 0,
    stroke: "#ccc",
    strokeWidth: 0
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zr4-c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 59l961 0l0 561.23l-961 0Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zr4-c1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 59l961 0l0 561.23l-961 0Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zr4-c2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 59l961 0l0 561.23l-961 0Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zr4-c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 59l961 0l0 561.23l-961 0Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zr4-c4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 59l961 0l0 561.23l-961 0Z",
    fill: "#000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinechartThumb);
export default __webpack_public_path__ + "static/media/linechart_thumb.6e01ab6a683b9125b4eea9aae1be8789.svg";
export { ForwardRef as ReactComponent };